<template>
  <button
    class="d-flex justify-content-center align-items-center m-1"
    style="
      user-select: none;
      color: white;
      border: none;
      cursor: pointer;
      width: 350px;
      height: 40px;
      border-radius: 0px 0px 12px 12px;
    "
    :style="buttonStyle"
    @click="handleClick"
  >
    <span
      class="text-center"
      style="
        width: 350px;
        height: 20px;
        font-family: 'Trebuchet MS', sans-serif;
        font-size: 16px;
        line-height: 20px;
        text-align: center;
        color: #232f61;
      "
    >
      {{ label }}
    </span>
  </button>
</template>

<script>
export default {
  props: {
    label: {
      required: false,
      type: [String, Number],
      default: "Email törzsadatok",
    },
  },
  computed: {
    buttonStyle() {
      const defaultStyle = {
        backgroundColor: "#bcbebf",
        border: "1px solid #929698",
      };

      if (this.$route.name === "jifadmin.emailmasterdata") {
        return {
          ...defaultStyle,
          backgroundColor: "#dacd91",
          border: "1px solid #bdb072",
        };
      }

      return defaultStyle;
    },
  },
  methods: {
    handleClick() {
      this.$router.push({ name: "jifadmin.emailmasterdata" });
    },
  },
};
</script>
<style scoped>
button:hover {
  opacity: 0.4;
}
</style>
